import { createContext, useContext, useState } from 'react';

// Create the context
const GenderContext = createContext();

// Create the provider
export const GenderProvider = ({ children }) => {
  const [selectedGender, setSelectedGender] = useState('0'); // default '0' = Select Gender

  return (
    <GenderContext.Provider value={{ selectedGender, setSelectedGender }}>
      {children}
    </GenderContext.Provider>
  );
};

// Custom hook to use the context
export const useGender = () => useContext(GenderContext);
